import React from "react";
import styles from "@/components/telemetry/common/StatusCodeBadge.module.css";

interface StatusCodeBadgeProps {
  statusCode: number;
}

function getStatusClass(statusCode: number): string {
  if (statusCode >= 200 && statusCode < 300) return styles.success ?? "";
  if (statusCode >= 400 && statusCode < 500) return styles.warning ?? "";
  if (statusCode >= 500) return styles.error ?? "";
  return styles.info ?? "";
}

function StatusCodeBadge({ statusCode }: StatusCodeBadgeProps) {
  return (
    <span className={`${styles.badge ?? ""} ${getStatusClass(statusCode)}`}>
      {statusCode}
    </span>
  );
}

export default StatusCodeBadge;
